export default __webpack_public_path__ + "static/media/download.c04e9b69.png";